import "./StepContainer.less";

import React, { Component } from "react";

import plantynLogo from "../../../assets/images/plantyn_logo.svg";
import scoodleLogo from "../../../assets/images/scoodle_icon_colour.svg";

class StepContainer extends Component {
	render() {
		return (
			<div>
				<div className="login-holder">
					<img alt="" className="logo" src={scoodleLogo} />
				</div>
				<div className="step">
					<div className="step-content-container">
						{this.props.children}
						<img alt="" className="plantyn_logo" src={plantynLogo} />
					</div>
				</div>
			</div>
		);
	}
}

export default StepContainer;



// WEBPACK FOOTER //
// ./src/components/Steps/StepContainer/StepContainer.js